// extracted by mini-css-extract-plugin
module.exports = {"langBlockContainer":"SwitchLanguageMobile_langBlockContainer__FQviM","langBlock":"SwitchLanguageMobile_langBlock__1xTop","active":"SwitchLanguageMobile_active__31PSZ"};